import Cookies from 'js-cookie';

export function isFromFacebook () {
  const value = Cookies.get('follow_complete');
  return value !== undefined;
}

export function isLogined () {
  const value = Cookies.get('current_user_type');
  return ['media_user', 'social_user'].includes(value);
}

export function toggleCookieFromFaceBook (flg) {
  if (flg) {
    Cookies.set('follow_complete', { path: '/' });
  } else {
    Cookies.remove('follow_complete', { path: '/' });
  }
}
